import { ArrowForwardOutlined } from "@mui/icons-material";
import { Box, Chip, Stack, Typography } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";

export function SourceTrace({
  sources, step, client, destination, compactPrefix
}: {
  sources: Array<string | null | undefined>;
  step?: string | null;
  client?: string | null;
  destination?: string | null;
  compactPrefix?: string;
}) {
  const { t } = useTranslation();
  const [groupExpanded, setGroupExpanded] = useState(false);
  const uniqueSources = [...new Set(sources.filter(
    (source): source is string => Boolean(source)
  ))];
  const groupedSources = compactPrefix
    ? uniqueSources.filter((source) => source.startsWith(compactPrefix)) : [];
  const visibleSources = compactPrefix && groupedSources.length > 1
    ? uniqueSources.filter((source) => !source.startsWith(compactPrefix))
    : uniqueSources;
  if (!uniqueSources.length) return null;
  return (
    <Stack direction="row" spacing={0.75} useFlexGap flexWrap="wrap"
      alignItems="center" sx={{ mt: 0.75 }}>
      <Typography variant="caption" color="text.secondary" fontWeight={750}
        sx={{ display: { xs: "none", sm: "inline" } }}>
        {t("common.source")}
      </Typography>
      {uniqueSources.map((source) => (
        visibleSources.includes(source) && (
          <Chip key={source} size="small" color="primary" variant="outlined"
            label={source} sx={{ fontWeight: 800 }} />
        )
      ))}
      {groupedSources.length > 1 && !groupExpanded && (
        <Chip size="small" color="primary" variant="outlined" clickable
          label={`${groupedSources.length} HU`}
          onClick={() => setGroupExpanded(true)} sx={{ fontWeight: 800 }} />
      )}
      {groupedSources.length > 1 && groupExpanded && groupedSources.map(
        (source) => (
          <Chip key={source} size="small" color="primary" variant="outlined"
            label={source} sx={{ fontWeight: 800 }} />
        )
      )}
      {groupedSources.length > 1 && groupExpanded && (
        <Chip size="small" clickable label={t("common.actions.collapse")}
          onClick={() => setGroupExpanded(false)} />
      )}
      {step && (
        <>
          <ArrowForwardOutlined sx={{ fontSize: 16, color: "text.disabled" }} />
          <Chip size="small" label={step} sx={{ fontWeight: 750 }} />
        </>
      )}
      {client && <Box component="span" sx={{ typography: "caption",
        color: "text.secondary" }}>{t("common.clientLabel")} {client}</Box>}
      {destination && <Box component="span" sx={{ typography: "caption",
        color: "text.secondary" }}>{t("common.destinationLabel")} {destination}</Box>}
    </Stack>
  );
}
